import { isUndefined } from '@aloft/toolkit-shared';

import { ColumnDataExtractionDefinition, Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';

export function getPropertyFromSummary<T extends 'feature' | 'adjustment'>(
  summary: Tkv2PairedCostSummaryInterfaceV2,
  id: string,
  column: ColumnDataExtractionDefinition<T>,
) {
  if (isUndefined(id)) {
    return undefined;
  }
  const { type, adjustmentType } = column;

  if (type === 'adjustment') {
    return id === 'subject'
      ? undefined
      : summary.results.comps?.[id]?.adjustments?.[adjustmentType];
  }

  const features =
    id === 'subject' ? summary.results.subject?.features : summary.results.comps?.[id]?.features;
  return features?.[adjustmentType];
}
